import * as React from 'react';
import { flow, map } from 'lodash';
import { formValueSelector, reduxForm, submit } from 'redux-form';
import { Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import SaveQuoteModalForm from './components/SaveQuoteModalForm';
import { bindActionCreators } from 'redux';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { push } from 'react-router-redux';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { IAuthState } from '../../../../services/auth/models';
import { QuoteStatus } from '../../../../data/api/models';

interface ISaveQuoteModalProps {
  auth: IAuthState;
  quote: IQuoteState;
  password: string;
  quoteReference: string;
  passwordConfirmation: string;
  actions: {
    submit(name: string);
    push(path: string);
    quote: IQuoteActions;
    auth: IAuthActions;
  };
  buttonText ?: string;
  submitting?: boolean;
  generalConditionsDocument?: string;
  renewal: boolean;
  calculateOnSave?: boolean;
}

interface ISaveQuoteModalStates {
  isQuoteSaved: boolean;
  showSaveQuoteModal: boolean;
}

class SaveQuoteModal extends React.Component<ISaveQuoteModalProps, ISaveQuoteModalStates> {
  public state = {
    isQuoteSaved: false,
    showSaveQuoteModal: false,
  };

  public static defaultProps: Partial<ISaveQuoteModalProps> = {
    buttonText: 'Save Quote',
  };

  private openSaveQuoteModal = () => {
    this.setState({
      showSaveQuoteModal: true,
    });
  }

  private handleSubmit = ({password, passwordConfirmation}) => {
    const { actions, change, dispatch, auth, quote, calculateOnSave } = this.props;
    dispatch(change('createAccount', true));

    this.setState({
      isQuoteSaved: true,
    });

    dispatch(change('generateDocuments', true));
    dispatch(change('emailSend', true));

    actions.quote.setPassword(password, passwordConfirmation);

    const calculate = (calculateOnSave ? calculateOnSave : false) || quote.application.status === QuoteStatus.QUOTE ||
      quote.application.status === QuoteStatus.REFERRAL_APPROVED;

    if (quote.isRetrievingQuote) {
      actions.quote.saveQuote(calculate).then(() => {
        this.autoLogin(password);
      });
    }

    if (!quote.isRetrievingQuote) {
      actions.quote.submitForm(null, calculate, true).then(() => {
        this.autoLogin(password);
      });
    }
  }

  private autoLogin = (password) => {
    const { actions, quote, auth } = this.props;
    const customer = quote.customer;
    const email = customer && customer[0].email;

    if (!auth.isAuthenticated && email && password) {
      actions.auth.login(email, password, '-');
    }
  }

  private handleCloseModal = () => {
    const { dispatch, change } = this.props;

    this.setState({
      showSaveQuoteModal: false,
    });

    dispatch(change('generateDocuments', false));
    dispatch(change('emailSend', false));
  }

  private handleGoToMyAccount = () => {
    const { actions, dispatch, change } = this.props;

    dispatch(change('generateDocuments', false));
    dispatch(change('emailSend', false));
    actions.push('/account/summary');
  }

  public render() {
    const { quote, password, passwordConfirmation, submitting } = this.props;
    const { showSaveQuoteModal, isQuoteSaved } = this.state;
    const customer = quote.customer;
    const quotes = quote.quotes.standard && quote.quotes.standard;
    const availableQuote = [];

    map(quotes, (quote, key) => {
      availableQuote.push(quote);
    });

    const hasErrors = availableQuote.length > 0 && availableQuote[0].errors.length > 0;
    const hasDeclines = availableQuote.length > 0 &&  availableQuote[0].declines.length > 0;
    const hasReferrals = availableQuote.length > 0 &&  availableQuote[0].referrals.length > 0;
    const hasCustomer = customer && customer.length > 0;

    return (
      <span>
        {!hasErrors && !hasDeclines && (!hasReferrals || quote.application.status === QuoteStatus.REFERRAL_APPROVED)
        && hasCustomer && (
          <Button
            type="button"
            disabled={!customer || submitting}
            className="btn btn-secondary margin-right pull-right notification-btn-size"
            onClick={this.openSaveQuoteModal}
          >
            {this.props.buttonText}
          </Button>
        )}

        <Modal show={showSaveQuoteModal} onHide={this.handleCloseModal} >
          <Modal.Header closeButton={true}>
            <Modal.Title>Save Your Quote</Modal.Title>
          </Modal.Header>
          <SaveQuoteModalForm
            onSubmit={this.handleSubmit}
            initialValues={{ password, passwordConfirmation }}
            onCloseModal={this.handleCloseModal}
            onGoToMyAccount={this.handleGoToMyAccount}
            isQuoteSaved={isQuoteSaved}
            generalConditionsDocument={this.props.generalConditionsDocument}
            renewal={this.props.renewal}
          />
        </Modal>
      </span>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state) => {
      const password = selector(state, 'password');
      const passwordConfirmation =  selector(state, 'passwordConfirmation');

      return {
        auth: state.auth,
        quote: state.quote,
        password,
        passwordConfirmation,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        submit: bindActionCreators(submit, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
        dispatch,
      },
    }),
  ),
])(SaveQuoteModal);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/SaveQuoteModal/index.tsx